export type AnalyticsEvent = {
  name: string;
  payload: Record<string, string | number | boolean | null | undefined>;
  at: string;
};

declare global {
  interface Window {
    dataLayer?: AnalyticsEvent[];
  }
}

const STORAGE_KEY = 'aitbc_events';

export function trackEvent(name: string, payload: AnalyticsEvent['payload'] = {}): AnalyticsEvent {
  const event: AnalyticsEvent = { name, payload, at: new Date().toISOString() };
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
  try {
    const previous = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]') as AnalyticsEvent[];
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...previous.slice(-49), event]));
  } catch {
    // Analytics must never break conversion flows.
  }
  window.dispatchEvent(new CustomEvent('aitbc:event', { detail: event }));
  return event;
}

export function readStoredEvents(): AnalyticsEvent[] {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]') as AnalyticsEvent[];
  } catch {
    return [];
  }
}
